import React from "react";
import horizontalLogo from "../../brand_assets/ng logo horizontal.svg";
import verticalLogo from "../../brand_assets/ng logo vertical.svg";

type BrandLogoProps = {
  className?: string;
  variant?: "horizontal" | "vertical";
};

export default function BrandLogo({
  className = "",
  variant = "horizontal",
}: BrandLogoProps) {
  return (
    <img
      alt=""
      aria-hidden="true"
      className={className}
      height={variant === "vertical" ? 132 : 77}
      src={variant === "vertical" ? verticalLogo : horizontalLogo}
      width={variant === "vertical" ? 336 : 675}
    />
  );
}
